export default "__VITE_ASSET__BiwUjt3g__"